module.exports = __webpack_public_path__ + "static/img/Meringue.82f2165.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Meringue.jpg
// module id = M24X
// module chunks = 0